<div
  id="{{ 'ranking-item-' + rankingUser().rankingPosition }}"
  class="ranking-item-container"
  (click)="publicProfile()"
  [ngClass]="{
    'user-item': isUser(),
    'ranking-item-hidden': hiddenInList()
  }">
  <div
    class="info-box info-box-position info-box-position-{{ rankingUser().rankingPosition }}"
    [ngClass]="{
      'info-box-position-out': rankingUser().rankingPosition >= 25,
      'info-box-position-top': rankingUser().rankingPosition <= 2
    }">
    @if (rankingUser().rankingPosition > 2) {
      <span [ngClass]="{ 'position-out': rankingUser().rankingPosition >= 25 }">
        {{ rankingUser().rankingPosition + 1 | number: '1.0-0' : ('common.culture' | translate) }}
      </span>
    }
  </div>
  <div
    class="info-box info-box-user-info"
    [ngClass]="{ 'info-box-user-info-isUser': isUser() }">
    <slotcom-avatar
      [userId]="rankingUser().userId"
      [isFriend]="rankingUser().isFriend">
    </slotcom-avatar>

    <p
      class="font username"
      [ngClass]="{ 'font-bold': isUser() }">
      {{ rankingUser().nickName }}
    </p>
    <div
      class="info-box-recurring info-box-recurring-container"
      [ngClass]="{ 'info-box-recurring-container-user': isUser() }">
      <div
        class="info-box-recurring"
        [ngClass]="{ 'info-box-recurring-user': isUser() }">
        <div class="bag-img"></div>
        <span class="font font-bold">
          {{ rankingUser().score | number: '1.0-0' : ('common.culture' | translate) }}
        </span>
      </div>
    </div>
  </div>
</div>
